import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexCareersRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/careers', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const debounceIndexCareersRequest = AwesomeDebouncePromise(indexCareersRequest, 300);
